import type { ApplicationDetail } from "../../pages/application-detail-page/application-detail-page.lib";
import type { ApplicationsTableItem } from "../../pages/applications-page/applications-page.lib";
import dayjs from "dayjs";

export type ExportApplicationItem = {
  id: string;
  exportFileName?: string;
};

type ClientType = "internal" | "external" | null;

const typeLabel = (clientType: ClientType, isMulti = false) =>
  clientType === "internal" ? (isMulti ? "внутренние" : "внутренняя") : isMulti ? "внешние" : "внешняя";

const currentDate = () => dayjs().format("DD-MM-YYYY HH-mm");

export const getExportFileNameFromTableItem = (application: ApplicationsTableItem, clientType: ClientType) => {
  const prefix = `заявка ${typeLabel(clientType)} ${currentDate()}`;
  const number = (application as { number?: bigint | number | null }).number;

  if (number != null) {
    return `${prefix} №${String(number)}.zip`;
  }

  if (application.id) {
    return `${prefix} №${application.id}.zip`;
  }

  return `${prefix}.zip`;
};

export const getExportFileNameFromDetail = (application: ApplicationDetail, clientType: ClientType) => {
  const prefix = `заявка ${typeLabel(clientType)} ${currentDate()}`;

  if (application.id.startsWith("№")) {
    return `${prefix} №${application.id.slice(1)}.zip`;
  }

  if (application.requestId) {
    return `${prefix} №${application.requestId}.zip`;
  }

  return `${prefix}.zip`;
};

export const getBatchExportFileName = (count: number, clientType: ClientType) =>
  `заявки ${typeLabel(clientType, true)} ${currentDate()} ${count}.zip`;

export const toExportItemsFromTable = (applications: ApplicationsTableItem[], clientType: ClientType): ExportApplicationItem[] =>
  applications
    .filter((application): application is ApplicationsTableItem & { id: string } => Boolean(application.id))
    .map((application) => ({
      id: application.id,
      exportFileName: getExportFileNameFromTableItem(application, clientType),
    }));

export const toExportItemFromDetail = (application: ApplicationDetail, clientType: ClientType): ExportApplicationItem => ({
  id: application.requestId,
  exportFileName: getExportFileNameFromDetail(application, clientType),
});
